import {useToasts} from 'react-toast-notifications';
import {useIntl} from 'react-intl';

const useAlerts = () => {
  const intl = useIntl();
  const {addToast} = useToasts();

  const success = (msg: string) => {
    addToast(msg, {appearance: 'success', autoDismiss: true});
  };

  const error = (msg: string) => {
    addToast(msg, {appearance: 'error', autoDismiss: true});
  };

  // legacy true by default to maintain backward compatibility
  // set legacy to false to use only the error message from the API
  const errorStatus = (e: {data?: string; status: number}, options: {legacy: boolean} = {legacy: true}) => {
    let errorMessage = intl.formatMessage({id: 'sharedError'});

    if (options.legacy === false) {
      return error(e?.data || errorMessage);
    }

    switch (e.status) {
      case 400: {
        errorMessage = intl.formatMessage({id: 'sharedBadRequest'});
        break;
      }
      case 401: {
        errorMessage = intl.formatMessage({id: 'sharedUnauthorized'});
        break;
      }
      case 403: {
        errorMessage = intl.formatMessage({id: 'sharedForbidden'});
        break;
      }
      case 404: {
        errorMessage = intl.formatMessage({id: 'sharedNotFound'});
        break;
      }
      case 500: {
        if (e.data && typeof e.data === 'string') {
          errorMessage = e.data;
        }
        break;
      }
    }
    error(errorMessage);
  };

  const warn = (msg: string) => {
    addToast(msg, {appearance: 'warning', autoDismiss: true});
  };

  const info = (msg: string) => {
    addToast(msg, {appearance: 'info', autoDismiss: true});
  };

  return {
    toast: {
      success,
      warn,
      error,
      info,
      errorStatus,
    },
  };
};

export default useAlerts;
